import { ProductLineEnum } from "../../enums";

export const isCurrentShuntStarted = (prodLineParams) => {
    if (ProductLineEnum.ProductPrincip.getContextValue(prodLineParams) != null && ProductLineEnum.ProductPrincip.getContextValue(prodLineParams) !== ""){
        return true;
    }
    else{
        return false;
    }
}